var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "column is-3-desktop is-2-fullhd is-hidden-touch" },
    [
      _c("div", { staticClass: "card sticky-column" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "pt-2 pb-4" }, [
            _c(
              "div",
              {
                staticClass: "has-text-centered is-size-3 has-text-weight-bold",
              },
              [
                _c("i", { staticClass: "far fa-copy" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedDocumentsIndex.length) +
                    "\r\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle is-5 has-text-centered" }, [
            _vm._v(" archivos seleccionados"),
          ]),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "m-0" }),
        _vm._v(" "),
        _c("div", { staticClass: "card-content has-text-centered" }, [
          _c("ul", [
            _vm.allFilesAreType("documento")
              ? _c(
                  "li",
                  {
                    class: _vm.canSignAll ? "my-2" : "my-2 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canSignAll
                          ? _vm.addAllToPila()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canSignAll
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-plus fa-fw" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                        _vm._v(" Agregar para firmar\r\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allFilesAreType("documento")
              ? _c(
                  "li",
                  {
                    class: _vm.canDownloadAll ? "my-2" : "my-2 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canDownloadAll
                          ? _vm.downloadAll()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canDownloadAll
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-download fa-fw" }),
                        _vm._v(" Descargar\r\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canMoveAll ? "my-2" : "my-2 disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canMoveAll
                      ? _vm.moveAll()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.canMoveAll ? "has-text-info" : "disabled-option",
                  },
                  [
                    _c("i", { staticClass: "fas fa-dolly fa-fw" }),
                    _vm._v(" Mover\r\n          "),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canDeleteAll ? "my-2" : "my-2 disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canDeleteAll
                      ? _vm.deleteAll()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.canDeleteAll
                      ? "has-text-danger"
                      : "disabled-option",
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash fa-fw" }),
                    _vm._v(" Eliminar\r\n          "),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "has-text-dark card-footer-item",
              on: {
                click: function ($event) {
                  return _vm.unselectDocuments()
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-times-circle fa-fw" }),
              _vm._v(" Limpiar\r\n      "),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }